import { useState, useEffect } from 'react';
import axios from 'axios';
import { axiosApi } from '../../api/setupApi';

const useCountsCisSiquijor = () => {
  const [counts, setCounts] = useState({
    cis_siquijor: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const { data } = await axiosApi.get('/cisSiquijor/getCounts');
        setCounts({ cis_siquijor: data?.cis_siquijor || 0 });
      } catch (err) {
        setError(err.message || err?.toString());
      } finally {
        setLoading(false);
      }
    };

    fetchCounts();
  }, []);

  return { counts, loading, error };
};

export default useCountsCisSiquijor;
